import { createContext, ReactNode, useContext, useEffect } from 'react';
import { AppContext } from './app-context';
import { localizer } from '../utils/localizer';

export interface LocalizeOptions {
  capitalize?: boolean;
}

const LocalizationContext = createContext<{ (namespace: string, key: string, options?: LocalizeOptions): string }>((_key) => "");

const LocalizationProvider = (props: { children: ReactNode }) => {
  const { state } = useContext(AppContext);

  const localize = (namespace: string, key: string, options?: LocalizeOptions): string => {
    return localizer(namespace, state.configuration.language, key, options);
  }

  const configLang = state.configuration.language

  useEffect(() => {
    const html = document.documentElement

    if (html.lang !== configLang)
      html.lang = configLang
  }, [configLang])

  return (
    <LocalizationContext.Provider value={localize}>
      {props.children}
    </LocalizationContext.Provider>
  )
}

export { LocalizationContext, LocalizationProvider };
